import { StyleSheet, View } from 'react-native';

import { classifyPaymentMethods } from 'components/payment-method/utils';
import { ActionButton } from 'components/ui/action-button';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

import { PaymentMethodDetails } from '../payment-method-details';
import { PaymentMethodIcon } from '../payment-method-icon';

import { SelectorSelectionProps } from './types';

export function SelectorSelection({
  methods,
  selectedMethodId = '',
  onChange,
  isDisabled,
}: SelectorSelectionProps) {
  const { selectedMethod } = classifyPaymentMethods(methods, selectedMethodId);

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <PaymentMethodIcon paymentMethod={selectedMethod} size="lg" bordered />
        <View style={styles.details}>
          <PaymentMethodDetails paymentMethod={selectedMethod} />
        </View>
      </View>
      <ActionButton
        testID="change-btn"
        width="auto"
        customStyles={styles.changeButton}
        onPress={onChange}
        disabled={isDisabled}
      >
        {t('change')}
      </ActionButton>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  content: {
    flex: 1,
    flexShrink: 1,
    flexDirection: 'row',
    gap: spacing.$4,
    minWidth: 0,
    paddingRight: spacing.$2,
  },
  details: {
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
  },
  changeButton: {
    flexShrink: 0,
  },
});
